// @react/hooks/useCalendarBooking.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { calendarBookingStore } from '@core/stores';

/**
 * React hook for BookingLink operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useCalendarBooking } from '@react/hooks';
 *
 * const BookingLinkList = observer(() => {
 *   const store = useCalendarBooking();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useCalendarBooking() {
  return calendarBookingStore;
}
